// Array of technobabble verbs
const verbs = [
  "activating",
  "modulating",
  "configuring",
  "synthesizing",
  "enhancing",
  "ionizing",
  "oscillating",
  "polarizing",
  "encrypting",
  "scanning",
  "amplifying",
  "calibrating",
  "deactivating",
  "reconfiguring",
  "augmenting",
  "stabilizing",
  "compensating",
  "transmitting",
  "compressing",
  "decompressing",
  "initializing",
  "reinitializing",
  "overloading",
  "upgrading",
  "downloading",
  "uploading",
  "rebooting",
  "quantizing",
  "dequantizing",
  "refracting",
  "defragmenting",
  "interpolating",
  "extrapolating",
  "analyzing",
  "deionizing",
  "rerouting",
  "bypassing",
  "sublimating",
  "condensing",
  "encrypting",
  "decrypting",
  "modulating",
  "demodulating",
  "replicating",
  "inverting",
  "converting",
  "disrupting",
  "projecting",
  "filtering",
  "infusing",
];

// Array of technobabble nouns
const nouns: string[] = [
  "flux capacitor",
  "warp drive",
  "quantum matrix",
  "neutron star",
  "photon beam",
  "gravity well",
  "time vortex",
  "launchdrive",
  "hyperdrive",
  "singularity",
  "force field",
  "event horizon",
  "tachyon emitter",
  "plasma conduit",
  "fusion reactor",
  "antimatter chamber",
  "dark matter core",
  "hologram projector",
  "teleportation deck",
  "dimensional rift",
  "space-time fabric",
  "wormhole generator",
  "nano particles",
  "gamma rays",
  "subspace antenna",
  "neutrino detector",
  "magnetic shield",
  "laser array",
  "ion cannon",
  "thermal vent",
  "cryo chamber",
  "orbital platform",
  "energy lattice",
  "data stream",
  "control matrix",
  "bio-sensor",
  "stellar map",
  "quantum computer",
  "resonance chamber",
  "phaser bank",
  "impulse engine",
  "thruster array",
  "navigation system",
  "communication relay",
  "artificial intelligence",
  "virtual environment",
  "encryption module",
  "dilithium crystal",
  "power grid",
  "sensor array",
];

// Example function to generate technobabble
//
export function technobabble() {
  const verb = verbs[Math.floor(Math.random() * verbs.length - 1)] as string;
  const noun = nouns[Math.floor(Math.random() * nouns.length - 1)] as string;
  return { verb, noun };
}

export function technobabbleGenerator() {
  const nounsCopy = [...nouns];
  const verbsCopy = [...verbs];
  return function generateTechnobabble() {
    const nounIndex = Math.floor(Math.random() * nounsCopy.length);
    const verbIndex = Math.floor(Math.random() * verbsCopy.length);
    const noun = nounsCopy[nounIndex];
    const verb = verbsCopy[verbIndex];

    nounsCopy.splice(nounIndex, 1);
    verbsCopy.splice(verbIndex, 1);

    return `${verb} the ${noun}`;
  };
}
